import { useCallback, useEffect, useState } from "react";
import PersonalAccount from "../../store/PersonalAccount";
import INTOUCH_API from "../../services/Api";
import useValidateForm from "../../hooks/useValidateForm";
import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";
export default function useController(callback, deps) {
  const { openModal } = useModalActions();
  const { isValidTextInput, validateTextInput } = useValidateForm();
  const [isValidMessage, setIsValidMessage] = useState(true);
  const [isTooLongMessage, setIsTooLongMessage] = useState(false);
  // 23.10: почту не спрашиваем, бэк отвечает на адрес аккаунта
  const [supportFormData, setSupportFormData] = useState({
    name: PersonalAccount.user?.firstName || "",
    message: "",
    "g-recaptcha-response": "",
  });
  const [isFormSending, setIsFormSending] = useState(false);
  const [isMessageSended, setIsMessageSended] = useState(false);
  const [isSendError, setIsSendError] = useState(false);
  // тоггл заставляет <GoogleReCaptcha> перевыполниться и выдать свежий токен
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "message") {
      setIsValidMessage(e.target.value.length >= 5);
      setIsTooLongMessage(e.target.value.length >= 2048);
    }
    if (name === "name") {
      validateTextInput(e.target.value);
    }
    setSupportFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsValidMessage(supportFormData.message.length >= 5);
    if (!supportFormData.message.length) return;
    setIsSendError(false);
    sendSupportForm(supportFormData);
  };

  const sendSupportForm = (formData) => {
    if (isFormSending) return;
    setIsFormSending(true);
    INTOUCH_API.requestManager(
      "sendSupportForm",
      formData,
      () => {
        // успех — модалку «отправлено» показываем ТОЛЬКО здесь. Раньше она
        // открывалась безусловно в onSubmit → юзер видел «успех» даже при отказе
        // капчи/сети (сообщение молча терялось). Чистим текст только на успехе.
        setIsMessageSended(true);
        openModal(MODAL_TYPES.SUPPORT_SENDED);
        setSupportFormData((prevState) => ({ ...prevState, message: "" }));
      },
      () => {
        // ошибка (в т.ч. проваленная/просроченная капча) — показываем сообщение,
        // текст НЕ чистим, чтобы можно было повторить отправку
        setIsSendError(true);
      }
    ).finally(() => {
      // reCAPTCHA-токен одноразовый и живёт ~2 мин → мятим свежий для следующей
      // попытки (иначе повторная отправка слала бы уже погашенный токен → отказ)
      setRefreshReCaptcha((v) => !v);
      setIsFormSending(false);
    });
  };

  // имя из профиля, если данные аккаунта догрузились после открытия страницы
  const accountName = PersonalAccount.user?.firstName;
  useEffect(() => {
    if (!accountName) return;
    setSupportFormData((prev) =>
      prev.name ? prev : { ...prev, name: accountName }
    );
  }, [accountName]);

  const handleVerify = useCallback(async (token) => {
    setSupportFormData((prevState) => ({
      ...prevState,
      "g-recaptcha-response": token,
    }));
  }, []);
  return {
    supportFormData,
    onSubmit,
    isFormSending,
    isMessageSended,
    isValidMessage,
    isTooLongMessage,
    handleChange,
    setSupportFormData,
    handleVerify,
    isValidTextInput,
    isSendError,
    refreshReCaptcha,
  };
}
